import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import imageOne from "../../resource/donations/annual-sub/2.png";
import imageTwo from "../../resource/donations/annual-sub/3.png";
import imageFour from "../../resource/donations/annual-sub/4.png";
import imageFive from "../../resource/donations/annual-sub/5.png";
import imageThree from "../../resource/donations/annual-sub/1.png";
import imageSix from "../../resource/donations/annual-sub/6 (3).png";
import TitleChnage from "../../Hook/TitleChnage";

const AnnualSubscription = () => {
  TitleChnage("Annual Subscription");
  const navigate = useNavigate();
  const handleClick = (event) => {
    const pathMap = {
      annualMembershipForm: "/annualMembershipForm",
      annualFundReq:"/annualFundReq"
    };

    const path = event.currentTarget.id;
    const targetPath = pathMap[path];

    if (targetPath) {
      navigate(targetPath);
    }
  };
  return (
    <div className="annualsub-page inside-pages">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>

      <h1 className="font-main p-4 mt-4">Annual Expense Fund</h1>

      <div className="text-center mt-6 h4-bold">
        <div>
          <p >A place for us to be with the  Buddha </p>
          <p >A place for us to be with the Dhamma </p>
          <p >A place for us to be with the Sangha</p>
          <p >A place for us to gain Punya—colossal in merit.</p>
        </div>
      </div>

      <p className="mt-6 h4 p-4">
      We are pleased to introduce the Annual Membership Fund at Bhaddeka Vihari Monastery and Meditation Centre, inviting individuals to make yearly contributions to support the well-being of the Sangha and the continued flourishing of the Monastery.
      </p>
      <p className="mt-5 h4 p-4">
      Donors are encouraged to select a meaningful date, such as a birthday, anniversary, or any special occasion, to commemorate their contribution. An annual membership is available for a subscription fee of $350, which will contribute to the ongoing support of various services, including maintenance activities, annual insurance premiums such as building, vehicle, and medical coverage, as well as property-related expenses such as government council rates and license fees etc. These funds are essential to sustain the Monastery’s yearly overheads.
      </p>
      <p className="mt-5 h4 p-4">
      Since the Sangha relies on the generosity of the lay community, these donations are essential for sustaining their livelihood and spiritual practice. Ongoing contributions help meet the financial needs of the Monastery and ensure the smooth operation of its activities, allowing for continued growth and harmony within the community.
      </p>
      <p className="mt-5 h4 p-4">
      By becoming a member of this scheme, you are helping to cultivate a peaceful, inclusive, and supportive environment for spiritual growth—an environment that will benefit not only the present community but also future generations.
      </p>
      <p className="mt-5 h4 p-4">
      If you wish to join this noble cause, please submit your information in the following membership form.
      </p>

      <p className=" h4 p-4">Contribute today and become an integral part of our mission to nurture spiritual well-being and to support the Sangha in their dedicated practice.</p>
      <p className="mt-5 h4 p-4">Thank you for your generosity and support.</p>

<div className="btn-group mt-6">
<img
          src={imageTwo}
          alt="Right Top Image"
          width={300}
          id="annualMembershipForm"
          className="curser-pointer"
          onClick={handleClick}
        />
</div>
      <div className="btn-group2 mt-5">
       
        <img src={imageFour} alt="Right Top Image" width={300} />
        <img src={imageFive} alt="Right Top Image" width={300} />
      </div>

      <div className="p-4 mt-6 text-center">
        <div className="mt-6 calander-box align-item-center">
          <div className="c-details text-left">
            <h2 className="intro-text ">Futher More Details : </h2>
            <p className="font-p mt-4">
              Monastery : 035608 0918 / 0459 729 738
            </p>
            <p className="font-p">Mr Gamini : 0422 069 359</p>
            <p className="font-p">WhatsApp : 0422 069 359</p>
            <p className="font-p">E-mail : info@bvp.org.au</p>
          </div>
          <div className="d-button">
                  <img
          src={imageSix}
          alt="Right Top Image"
          width={300}
          id="annualFundReq"
         onClick={handleClick}
          className="curser-pointer"
        />
                    </div>
        </div>
      </div>

      <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image" width={600} />
      </div>
    </div>
  );
};

export default AnnualSubscription;
